import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home'
import ContactInfo from '../components/ContactInfo'
import Leadership from '../components/Leadership'
import News from '../components/News'
import Publications from '../components/Publications'
import CryoEM from '../components/CryoEM'


Vue.use(Router)

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: '/',
      component: Home
    },
    {
      path: '/leadership',
      name: 'leadership',
      component: Leadership
    },
    {
      path: '/contactinfo',
      name: 'contactinfo',
      component: ContactInfo
    },
    {
      path: '/news',
      name: 'news',
      component: News
    },
    {
      path: '/publications',
      name: 'publications',
      component: Publications
    },
    {
      path: '/cryoem',
      name: 'cryoem',
      component: CryoEM
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js